import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import PropTypes from 'prop-types';

import { userInfoState } from '@bo-recoil/common/user/atom';
import authApi from '@bo-apis/common/authApi';

const UserInfoProvider = ({ children }) => {
  const setUserInfo = useSetRecoilState(userInfoState);
  useEffect(() => {
    authApi.info().then(({ result }) => {
      setUserInfo(result);
    });
  }, [setUserInfo]);

  return <>{children}</>;
};

UserInfoProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserInfoProvider;
